import { render, staticRenderFns } from "./JImageUpload.vue?vue&type=template&id=365d6523&scoped=true"
import script from "./JImageUpload.vue?vue&type=script&lang=js"
export * from "./JImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d6523",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365d6523')) {
      api.createRecord('365d6523', component.options)
    } else {
      api.reload('365d6523', component.options)
    }
    module.hot.accept("./JImageUpload.vue?vue&type=template&id=365d6523&scoped=true", function () {
      api.rerender('365d6523', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JImageUpload.vue"
export default component.exports